import type { DeliveryDetail } from '@citibox-panel/api-client';

// The cerradura as the detail carries it — inside the «buzón» since CBX-10954, hence read off
// `box.lock` by every caller.
type DetailLock = NonNullable<DeliveryDetail['box']>['lock'];

// Whether the «Entrega»'s cerradura has code sequences to consult — the gate of the lock-codes
// block. The sequences live in devices-service and are read by `lock.id` (CBX-10985), so a lock
// that was never migrated there carries `id: null` and has nothing to read: offering the block
// would fire a read condemned to 404. Presence of `lock` alone is NOT the gate — a delivery can
// carry a cerradura that devices does not know. Fails closed: no lock, no id, or a blank id → no
// block. A delivery with no «buzón» reaches this as `null` too, since the cerradura hangs off it.
export function hasLockCodes(lock: DetailLock): boolean {
  return lock?.id !== null && lock?.id !== undefined && lock.id !== '';
}
